import { Component } from '@angular/core';

@Component({
  selector: 'app-lite-interest-section',
  imports: [],
  templateUrl: './lite-interest-section.html',
  styleUrl: './lite-interest-section.css',
})
export class LiteInterestSection {}
